var Default = {
  allow_sharp_comments: true,
  allow_semicolon_comments: false,
  allow_empty_lines: false,
  allow_comments_only_at_top: true,
  max_line_length: undefined,
  alphabet: undefined
};
export { Default };
/* No side effect */